import { styled, useTheme } from '@mui/system';
import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../../services/admin';

import { useMediaQuery } from '@mui/material';
import {
  LoginFormContainer,
  LoginFormContents,
  LoginFormFieldWrapper,
  LoginFormFooter,
  LoginFormFooterCol,
  LoginFormForm,
  LoginFormHeading,
  LoginFormIcon,
  LoginFormImage,
  LoginFormWrapper,
} from '../Login/Login';
import './RequestPasswordResetForm.scss';

const BackToLoginWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
  alignSelf: 'stretch',
  cursor: 'pointer',
  '& small': {
    color: '#686868',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 17,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '27.54px', // 162%
  },
});

export const BackToLogin = ({link}) => {
  const navigate = useNavigate();

  return (
    <BackToLoginWrapper onClick={() => link ? navigate(link) : navigate('/admin/login')}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path
          d="M10.5 0.3125C11.4236 0.3125 12.309 0.430556 13.1562 0.666667C14.0035 0.902778 14.8021 1.23611 15.5521 1.66667C16.3021 2.09722 16.9757 2.61806 17.5729 3.22917C18.1701 3.84028 18.691 4.51736 19.1354 5.26042C19.5799 6.00347 19.9167 6.79861 20.1458 7.64583C20.375 8.49306 20.4931 9.38194 20.5 10.3125C20.5 11.2361 20.3819 12.1215 20.1458 12.9688C19.9097 13.816 19.5764 14.6146 19.1458 15.3646C18.7153 16.1146 18.1944 16.7882 17.5833 17.3854C16.9722 17.9826 16.2951 18.5035 15.5521 18.9479C14.809 19.3924 14.0139 19.7292 13.1667 19.9583C12.3194 20.1875 11.4306 20.3056 10.5 20.3125C9.57639 20.3125 8.69097 20.1944 7.84375 19.9583C6.99653 19.7222 6.19792 19.3889 5.44792 18.9583C4.69792 18.5278 4.02431 18.0069 3.42708 17.3958C2.82986 16.7847 2.30903 16.1076 1.86458 15.3646C1.42014 14.6215 1.08333 13.8264 0.854167 12.9792C0.625 12.1319 0.506944 11.2431 0.5 10.3125C0.5 9.38889 0.618056 8.50347 0.854167 7.65625C1.09028 6.80903 1.42361 6.01042 1.85417 5.26042C2.28472 4.51042 2.80556 3.83681 3.41667 3.23958C4.02778 2.64236 4.70486 2.12153 5.44792 1.67708C6.19097 1.23264 6.98611 0.895833 7.83333 0.666667C8.68056 0.4375 9.56944 0.319444 10.5 0.3125ZM10.5 18.9792C11.2986 18.9792 12.066 18.875 12.8021 18.6667C13.5382 18.4583 14.2257 18.1667 14.8646 17.7917C15.5035 17.4167 16.0903 16.9653 16.625 16.4375C17.1597 15.9097 17.6111 15.3264 17.9792 14.6875C18.3472 14.0486 18.6389 13.3576 18.8542 12.6146C19.0694 11.8715 19.1736 11.1042 19.1667 10.3125C19.1667 9.51389 19.0625 8.74653 18.8542 8.01042C18.6458 7.27431 18.3542 6.58681 17.9792 5.94792C17.6042 5.30903 17.1528 4.72222 16.625 4.1875C16.0972 3.65278 15.5139 3.20139 14.875 2.83333C14.2361 2.46528 13.5451 2.17361 12.8021 1.95833C12.059 1.74306 11.2917 1.63889 10.5 1.64583C9.70139 1.64583 8.93403 1.75 8.19792 1.95833C7.46181 2.16667 6.77431 2.45833 6.13542 2.83333C5.49653 3.20833 4.90972 3.65972 4.375 4.1875C3.84028 4.71528 3.38889 5.29861 3.02083 5.9375C2.65278 6.57639 2.36111 7.26736 2.14583 8.01042C1.93056 8.75347 1.82639 9.52083 1.83333 10.3125C1.83333 11.1111 1.9375 11.8785 2.14583 12.6146C2.35417 13.3507 2.64583 14.0382 3.02083 14.6771C3.39583 15.316 3.84722 15.9028 4.375 16.4375C4.90278 16.9722 5.48611 17.4236 6.125 17.7917C6.76389 18.1597 7.45486 18.4514 8.19792 18.6667C8.94097 18.8819 9.70833 18.9861 10.5 18.9792ZM8.07292 9.64583H15.1667V10.9792H8.07292L10.9688 13.8333L10.0312 14.7917L5.51042 10.3125L10.0312 5.83333L10.9688 6.79167L8.07292 9.64583Z"
          fill="#686868"
        />
      </svg>
      <small>back to log in</small>
    </BackToLoginWrapper>
  );
};

const ResetFormContents = styled(LoginFormContents)({
  padding: '0 32px',
});

export const ResetFormFieldWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 40,
  alignSelf: 'stretch',
});

export const ResetFormField = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 16,
  alignSelf: 'stretch',
  '& h4': {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 25,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '37.5px', // 150%
  },
  '& p': {
    color: '#686868',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24.3px', // 162%
    maxWidth: 500,
    alignSelf: 'stretch',
    width: '100%',
    margin: '0 auto',
    '& > span': {
      color: '#686868',
      fontFamily: 'Montserrat',
      fontSize: 15,
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '24.3px',
    },
  },
});

const ResetFormFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: 232,
  marginTop: 40,
  '& p': {
    color: '#686868',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24.3px', // 162%
    '& span': {
      cursor: 'pointer',
      color: '#5284e0',
      fontFamily: 'Montserrat',
      fontSize: 17,
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '27.54px',
    },
  },
  [theme.breakpoints.down('md')]: {
    marginTop: 0,
    paddingBottom: 32,
  },
}));

const ResetFormRequestFooter = styled(LoginFormFooter)({
  gap: 24,
});

const RequestPasswordResetForm = () => {
  const theme = useTheme();
  const mediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const passwordRequest = async () => {
    setSubmitted(true);
    await forgotPassword({ email });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    passwordRequest();
  };

  return (
    <>
      <LoginFormContainer>
        <LoginFormWrapper>
          <LoginFormImage src={mediumScreen ? '/login-form__image-md.webp' : '/login-form__image.webp'} />
          <LoginFormForm>
            <LoginFormHeading>
              <h3>Welcome to</h3>
              <h2>
                YOUR<span>WAY</span>HOME
              </h2>
            </LoginFormHeading>
            <ResetFormContents onSubmit={handleSubmit}>
              {!submitted ? (
                <>
                  <ResetFormFieldWrapper>
                    <ResetFormField>
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="52" viewBox="0 0 50 67" fill="none">
                        <path
                          d="M25 0.6875C20.856 0.6875 16.8817 2.3337 13.9515 5.26396C11.0212 8.19421 9.375 12.1685 9.375 16.3125V22.5625H6.25C4.5924 22.5625 3.00268 23.221 1.83058 24.3931C0.65848 25.5652 0 27.1549 0 28.8125V60.0625C0 61.7201 0.65848 63.3098 1.83058 64.4819C3.00268 65.654 4.5924 66.3125 6.25 66.3125H43.75C45.4076 66.3125 46.9973 65.654 48.1694 64.4819C49.3415 63.3098 50 61.7201 50 60.0625V28.8125C50 27.1549 49.3415 25.5652 48.1694 24.3931C46.9973 23.221 45.4076 22.5625 43.75 22.5625H40.625V16.3125C40.625 14.2606 40.2208 12.2288 39.4356 10.3331C38.6504 8.43736 37.4995 6.71487 36.0485 5.26396C34.5976 3.81304 32.8751 2.66211 30.9794 1.87688C29.0837 1.09165 27.0519 0.6875 25 0.6875ZM25 6.625C30.3438 6.625 34.6875 10.9688 34.6875 16.3125V22.5625H15.3125V16.3125C15.3125 10.9688 19.6562 6.625 25 6.625ZM25.5937 30.375C28.5312 30.375 30.875 31.0312 32.5625 32.3125C34.25 33.625 35.0938 35.375 35.0938 37.5625C35.0938 38.9375 34.625 40.1562 33.7188 41.3125C32.8125 42.4375 31.625 43.3125 30.1875 43.9688C29.375 44.4375 28.8438 44.9062 28.5625 45.4375C28.2813 46 28.125 46.6875 28.125 47.5625H21.875C21.875 46 22.1875 44.9375 22.7812 44.1875C23.4375 43.4375 24.5 42.5625 26.125 41.5625C26.9375 41.125 27.5938 40.5625 28.125 39.875C28.5625 39.2188 28.8125 38.4375 28.8125 37.5625C28.8125 36.625 28.5312 35.9375 27.9688 35.4062C27.4062 34.8438 26.5625 34.5938 25.5937 34.5938C24.75 34.5938 24.0625 34.8125 23.4375 35.25C22.9375 35.6875 22.625 36.3438 22.625 37.2188H16.4688C16.3125 35.0625 17.1875 33.1875 18.9062 32.0625C20.5938 30.9375 22.8125 30.375 25.5937 30.375ZM21.875 50.6875H28.125V56.9375H21.875V50.6875Z"
                          fill="#5284E0"
                        />
                      </svg>
                      <h4>Forgot Password?</h4>
                      <p>
                        Enter your email address associated with your account and we'll send you a link to reset your
                        password.
                      </p>
                    </ResetFormField>
                  </ResetFormFieldWrapper>
                  <LoginFormFieldWrapper>
                    <LoginFormIcon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none">
                        <path
                          d="M10.17 24.5C10.0569 24.1787 9.99944 23.8406 10 23.5V16.5C10 15.732 10.289 15.03 10.764 14.5H3C2.20435 14.5 1.44129 14.8161 0.87868 15.3787C0.316071 15.9413 0 16.7044 0 17.5V18.215C0 21.933 4.21 24.5 10 24.5H10.17ZM16 6.5C16 4.9087 15.3679 3.38258 14.2426 2.25736C13.1174 1.13214 11.5913 0.5 10 0.5C8.4087 0.5 6.88258 1.13214 5.75736 2.25736C4.63214 3.38258 4 4.9087 4 6.5C4 8.0913 4.63214 9.61742 5.75736 10.7426C6.88258 11.8679 8.4087 12.5 10 12.5C11.5913 12.5 13.1174 11.8679 14.2426 10.7426C15.3679 9.61742 16 8.0913 16 6.5ZM13.5 14.5C12.837 14.5 12.2011 14.7634 11.7322 15.2322C11.2634 15.7011 11 16.337 11 17V17.191L17.5 20.441L24 17.191V17C24 16.337 23.7366 15.7011 23.2678 15.2322C22.7989 14.7634 22.163 14.5 21.5 14.5H13.5ZM24 18.309L17.724 21.447C17.6545 21.4818 17.5778 21.5 17.5 21.5C17.4222 21.5 17.3455 21.4818 17.276 21.447L11 18.31V23C11 23.663 11.2634 24.2989 11.7322 24.7678C12.2011 25.2366 12.837 25.5 13.5 25.5H21.5C22.163 25.5 22.7989 25.2366 23.2678 24.7678C23.7366 24.2989 24 23.663 24 23V18.309Z"
                          fill="#A8A8A8"
                        />
                      </svg>
                    </LoginFormIcon>
                    <input type="email" name="username" required placeholder="Email" onChange={handleEmailChange} />
                  </LoginFormFieldWrapper>
                  <ResetFormRequestFooter>
                    <LoginFormFooterCol>{!submitted && <button type="submit">SEND REQUEST</button>}</LoginFormFooterCol>
                    <BackToLogin />
                  </ResetFormRequestFooter>
                </>
              ) : (
                <ResetFormFieldWrapper>
                  <ResetFormField>
                    <svg xmlns="http://www.w3.org/2000/svg" width="66" height="57" viewBox="0 0 66 57" fill="none">
                      <path
                        d="M51.1874 55.3398C50.8953 55.6326 50.5482 55.8649 50.1662 56.0233C49.7841 56.1818 49.3746 56.2634 48.961 56.2634C48.5474 56.2634 48.1378 56.1818 47.7558 56.0233C47.3737 55.8649 47.0267 55.6326 46.7345 55.3398L40.0394 48.6446C39.747 48.3523 39.5151 48.0052 39.3568 47.6231C39.1986 47.2411 39.1171 46.8317 39.1171 46.4182C39.1171 46.0047 39.1986 45.5953 39.3568 45.2132C39.5151 44.8312 39.747 44.4841 40.0394 44.1917C40.6299 43.6012 41.4307 43.2695 42.2658 43.2695C42.6793 43.2695 43.0888 43.3509 43.4708 43.5092C43.8528 43.6674 44.1999 43.8994 44.4923 44.1917L48.9452 48.6446L60.1249 37.465C60.4172 37.1726 60.7644 36.9407 61.1464 36.7824C61.5284 36.6242 61.9378 36.5428 62.3513 36.5428C62.7648 36.5428 63.1743 36.6242 63.5563 36.7824C63.9383 36.9407 64.2854 37.1726 64.5778 37.465C64.8702 37.7574 65.1021 38.1045 65.2603 38.4865C65.4186 38.8685 65.5 39.278 65.5 39.6914C65.5 40.1049 65.4186 40.5144 65.2603 40.8964C65.1021 41.2784 64.8702 41.6255 64.5778 41.9179L51.1874 55.3398ZM32.3336 51.2659H6.81619C3.34229 51.2659 0.5 48.4236 0.5 44.9497V7.05252C0.5 3.57861 3.34229 0.736328 6.81619 0.736328H57.3457C60.8196 0.736328 63.6619 3.57861 63.6619 7.05252V28.1486C60.2939 26.5463 56.575 25.8229 52.8519 26.0458C49.1288 26.2686 45.5227 27.4305 42.3698 29.4231C39.217 31.4157 36.62 34.1742 34.8209 37.4414C33.0218 40.7085 32.0792 44.378 32.081 48.1078C32.081 49.1815 32.1757 50.2237 32.3336 51.2659ZM30.4072 28.117C31.4178 28.7486 32.7442 28.7486 33.7548 28.117L56.0825 14.1582C56.3992 13.9805 56.6765 13.7403 56.8976 13.4523C57.1188 13.1642 57.2792 12.8343 57.3692 12.4825C57.4591 12.1306 57.4768 11.7642 57.421 11.4053C57.3653 11.0465 57.2373 10.7027 57.0448 10.3947C56.8524 10.0868 56.5994 9.82108 56.3013 9.61372C56.0031 9.40636 55.666 9.26164 55.3104 9.18834C54.9547 9.11503 54.5878 9.11465 54.232 9.18723C53.8762 9.25981 53.5388 9.40383 53.2402 9.61058L32.081 22.843L10.9217 9.61058C10.6232 9.40383 10.2858 9.25981 9.92993 9.18723C9.57411 9.11465 9.20725 9.11503 8.85157 9.18834C8.49589 9.26164 8.15879 9.40636 7.86066 9.61372C7.56253 9.82108 7.30957 10.0868 7.1171 10.3947C6.92463 10.7027 6.79664 11.0465 6.74089 11.4053C6.68514 11.7642 6.70278 12.1306 6.79275 12.4825C6.88271 12.8343 7.04313 13.1642 7.26429 13.4523C7.48545 13.7403 7.76276 13.9805 8.07943 14.1582L30.4072 28.117Z"
                        fill="#5284E0"
                      />
                    </svg>
                    <h4>Make sure that’s you!</h4>
                    <p>
                      We sent an email to <span>{email}</span>
                      <br />
                      Please check your inbox and follow the reset <br /> instructions.
                    </p>
                  </ResetFormField>
                  <ResetFormFooter>
                    <p>Did not received any email? Please check your spam folder.</p>
                    <p>
                      or <span onClick={() => setSubmitted(!submitted)}>Send Email Again</span>
                    </p>
                  </ResetFormFooter>
                </ResetFormFieldWrapper>
              )}
            </ResetFormContents>
          </LoginFormForm>
        </LoginFormWrapper>
      </LoginFormContainer>

      {/* <div className="login-container">
                {isLoading &&
                    <Alert variant='primary'>
                        Please wait...
                    </Alert>
                }
                {isFail &&
                    <Alert variant='danger'>
                        {failMessage}
                    </Alert>
                }
                {!isSuccess &&
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor='email'>Email</label>
                            <input
                                type='email'
                                name='email'
                                id='email'
                                className='email-reset-request'
                                onChange={handleEmailChange} />
                            <button type="submit">Reset</button>
                        </div>
                    </form>
                }
                {isSuccess &&
                    <Alert variant='success'>
                        A reset link was sent to your email: {email}
                    </Alert>
                }
            </div> */}
    </>
  );
};

export default memo(RequestPasswordResetForm);
